// extracted by mini-css-extract-plugin
module.exports = {"badge_rtl":"_3InZdHKE3uFrNeRETP7wmk"};